import { Button } from '@atoms';
import { CloseIcon } from '@atoms/Icons/CloseIcon';
import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';

interface IEditNoteModalProps {
  open: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onSubmit: (note: string) => void;
  note: string;
}

export const EditNoteModal = ({
  open,
  isLoading,
  onCancel,
  onSubmit,
  note,
}: IEditNoteModalProps) => {
  const [editingNote, setEditingNote] = useState(note);

  useEffect(() => {
    if (open) {
      setEditingNote(note);
    }
  }, [note, open]);

  const handleSave = () => {
    onSubmit(editingNote);
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: '10px',
          minWidth: '1000px',
          height: '681px',
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box py="24px" px="32px" height="100%" width="100%">
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5"></Typography>
            <IconButton
              onClick={onCancel}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: '24px',
                lineHeight: '20px',
                color: '#464F60',
                whiteSpace: 'normal',
                marginBottom: '18px',
              }}
            >
              Notes
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={18}
              value={editingNote}
              onChange={(e) => setEditingNote(e.target.value)}
              placeholder="Enter your note here"
              sx={{
                marginTop: '16px',
                backgroundColor: '#ffffff',
                borderRadius: '8px',
              }}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="inherit"
          onClick={onCancel}
          sx={{
            width: 'fit-content',
            paddingX: '10px',
            borderRadius: '10px',
            marginTop: '8px',
            marginBottom: '12px',
          }}
        >
          <Box component="div" display="flex" gap={1.25}>
            <Typography component="span" color="text.white" variant="body2">
              Cancel
            </Typography>
          </Box>
        </Button>
        <LoadingButton
          variant="contained"
          color="success"
          loading={isLoading}
          onClick={handleSave}
          sx={{
            width: 'fit-content',
            paddingX: '30px',
            paddingY: '10px',
            borderRadius: '10px',
            marginTop: '8px',
            marginBottom: '12px',
          }}
        >
          <Typography component="span" color="text.white" variant="body2">
            Done
          </Typography>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
